import { hasCapability, type User } from "../base";

export const debug = {
  read: (user: User) => hasCapability(user, "debug.read"),
};
